import { generateSHA1 } from 'helpers/CryptoHelper';
import { add, query, update } from 'helpers/QueryHelper';
import moment from 'moment';

export const checkExistsEmail = (email: string) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await query('p_SACHSO_USERS_CheckByEmail', { email: email });
      if (response?.[0]?.id) {
        resolve(response[0]);
      } else {
        reject(null);
      }
    } catch (error) {
      reject(null);
    }
  });
};

export const addUser = (parameters: {
  email: string; // bắt buộc
  password: string; // bắt buộc
  fullName: string; // bắt buộc
  phone?: string;
  sex?: number;
  dateofBirth?: string;
  schoolTypeId: number; // bắt buộc cấp học 0 -> 3
  cityId?: number;
  departmentId?: string; // ("Phòng giáo dục")
  schoolName?: string;
  createdBy?: string; // email người tạo
  classId?: number; // bắt buộc - lớp mấy 0 -> 12
  status: 'ACTIVE' | 'DEACTIVE';
}) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const createdDate = moment().format('YYYY-MM-DD hh:mm:ss');
      const passwordScript = generateSHA1(parameters.password); //password phải được hash trước khi lưu
      const res = await add('Users', { ...parameters, password: passwordScript, createdDate }, '', 'AMES247');
      if (res?.id) {
        return resolve(res);
      } else {
        reject(res);
      }
    } catch (error) {
      reject(error);
    }
  });
};

export const updateUser = ({
  userId,
  parameters,
}: {
  userId: number;
  parameters: {
    fullName?: string;
    phone?: string;
    sex?: number;
    password?: string;
    dateofBirth?: string;
    schoolTypeId?: number;
    cityId?: number;
    departmentId?: string; // ("Phòng giáo dục")
    schoolName?: string;
    classId?: number;
    status?: 'ACTIVE' | 'DEACTIVE';
    modifiedBy: number; //ID của người sửa
  };
}) => {
  return new Promise<any>(async (resolve, reject) => {
    try {
      const modifiedDate = moment().format('YYYY-MM-DD hh:mm:ss');
      const res = await update('Users', String(userId), { ...parameters, modifiedDate }, '', 'AMES247');
      if (res?.rowsAffected === 1) {
        return resolve(res);
      } else {
        reject(res);
      }
    } catch (error) {
      reject(error);
    }
  });
};
